import yup, { enumValidator, arrayValidator, conditionValueValidator } from '~/utils/validators.yup';
import { COMPARED_OPTIONS } from '~/config/constants';

export const conditionPassiveDetailRule = {
    conditionPassiveDetail: yup.object().shape({
        conditionPassiveEffects: arrayValidator,
        conditionPassiveOption: enumValidator(COMPARED_OPTIONS),
        conditionPassiveValue: conditionValueValidator('conditionPassiveEffects'),
        conditionPassiveModifiedValue: conditionValueValidator('conditionPassiveEffects'),
    }),
};
